import type { FC } from 'react'
import { useState } from 'react'

import ReopenButton from './ReopenButton'
import ReopenSectionPanel from './ReopenSectionPanel'
import type { SectionName } from './types'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  sectionName: SectionName
  disabled?: boolean
}

const ReopenSection: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  sectionName,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <>
      <ReopenButton disabled={disabled} onClick={() => setIsOpen(true)} />
      {isOpen && (
        <ReopenSectionPanel
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          sectionName={sectionName}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}

export default ReopenSection
